import { render, staticRenderFns } from "./JobPreviewRealIntentionSp.vue?vue&type=template&id=1554a305&scoped=true"
import script from "./JobPreviewRealIntentionSp.vue?vue&type=script&lang=js"
export * from "./JobPreviewRealIntentionSp.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewRealIntentionSp.vue?vue&type=style&index=0&id=1554a305&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1554a305",
  null
  
)

export default component.exports